/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_LinkInputs */

const en_common_link = /** @type {(inputs: Common_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const es_common_link = /** @type {(inputs: Common_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincular`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Common_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_link = /** @type {((inputs?: Common_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_link(inputs)
	return en_common_link(inputs)
});